export const handleModalityUpdate = value => dispatch => dispatch({ type: 'UPDATE_MODALITIES', data:value })